<ul *ifSize="'XL'">
  @for (item of navigation; track item; let isLast = $last) {
    <li class="account-navigation-item"
      [class.account-navigation-item--last]="isLast"
      [attr.sl-account-menu-button]="item.link"
      [attr.cy-menuItem]="item.link ? item.link : 'empty'">
      <a [routerLink]="item.link"
        class="s1 flex">
        <i class="m-r"
          style="font-size: 1.2rem;"
          [ngClass]="'icon-'+ item.icon"></i>&nbsp;<span class="fw-medium">{{item.label}}</span>
        </a>
      </li>
    }
    <li>
      <logout-button></logout-button>
    </li>
  </ul>

  <ul [grid]="2"
    [gridColumnGap]="'16px'"
    [gridRowGap]="'16px'"
    *ifSize="'SM'">
    @for (item of navigation; track item; let index = $index) {
      <li
        class="bg-col-w"
        [attr.sl-account-menu-button]="item.link"
        [gridColumn]="1">
        <a class="p-t-6 p-b-5 p-l-2 p-r-2 flex-column flex-middle"
          [routerLink]="item.link">
          <i [ngClass]="'icon-'+ item.icon"
          style="font-size: 1.5rem;"></i>
          <p class="s1 center p-t-2 fw-medium-s">{{item.mobileLabel || item.label}}</p>
        </a>
      </li>
    }
    <li [gridColumn]="2">
      <logout-button class="m-t-6 block"></logout-button>
    </li>
  </ul>